module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_sekundærlogo_sentrert_neg.f383b517.svg";